import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { BulkNetworkActionValidator } from '../bulk.network.action.validator';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';

export class RemoteShellActionValidator extends BulkNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = false;

  protected _canPerformBulkAction(records: Array<ProtectedEntity>): boolean {
    if (records.length > Constants.RemoteShell.endpointsSelectionLimit) {
      return false;
    }

    for (const record of records) {
      if (!ProtectedEntitiesHelper.isComputer(record) || !ProtectedEntitiesHelper.isManaged(record)) {
        return false;
      }
    }

    if (Application.Main.user.mdrSuperAnalyst && Application.Main.checkDefaultConditionsForRemoteShell()) {
      return true;
    }

    return Application.Main.checkIfUserCanUseRemoteShellForCurrentCompany();
  }
}
